import React, { useRef } from 'react';
import uniqid from '../../helpers/uniqid';

/**
 * Pill toggle switch — the sliding-knob switch from the design system, as
 * opposed to SwitchButton, which is the square hardware-style toggle used
 * across the timeline and studio panels.
 *
 * @param {string} name - input name, passed back to changeFn
 * @param {boolean} checked
 * @param {boolean} disabled
 * @param {string} ariaLabel - accessible name when there is no visible label
 * @param {(checked: boolean, name: string) => void} changeFn
 */
const ToggleSwitch = ({
                          name = '',
                          value = '',
                          checked = false,
                          disabled = false,
                          className = '',
                          ariaLabel = '',
                          changeFn = () => {}
                      }) => {
    const idAttr = useRef(uniqid());

    return (
        <label
            htmlFor={idAttr.current}
            className={`appToggleSwitch ${className}`.trim()}>
            <input
                id={idAttr.current}
                type="checkbox"
                role="switch"
                name={name}
                value={value}
                checked={checked}
                disabled={disabled}
                aria-label={ariaLabel || undefined}
                onChange={(e) => changeFn(e.target.checked, name)}/>
            <span className="appToggleSwitch__track">
                <span className="appToggleSwitch__knob"/>
            </span>
        </label>
    );
};

export default ToggleSwitch;
